import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { HexColorPicker, HexColorInput } from 'react-colorful'
import { makeStyles } from '@material-ui/core/styles'

const PICKER_WIDTH = 200
const POPOVER_HEIGHT = 280

const ColorPickerField = ({ value, onChange, disabled }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [position, setPosition] = useState({ top: 0, left: 0 })
  const triggerRef = useRef(null)

  const openPicker = () => {
    if (disabled) return
    const rect = triggerRef.current.getBoundingClientRect()
    const spaceBelow = window.innerHeight - rect.bottom
    const top =
      spaceBelow >= POPOVER_HEIGHT
        ? rect.bottom + window.scrollY + 6
        : rect.top + window.scrollY - POPOVER_HEIGHT - 6
    let left = rect.left + window.scrollX
    if (left + PICKER_WIDTH > window.innerWidth) {
      left = window.innerWidth - PICKER_WIDTH - 8
    }
    setPosition({ top, left })
    setOpen(true)
  }

  useEffect(() => {
    if (!open) return
    const close = (e) => {
      if (
        !document.querySelector('[data-colorpicker-popover]')?.contains(e.target) &&
        !triggerRef.current?.contains(e.target)
      ) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [open])

  return (
    <div ref={triggerRef} className={classes.wrapper}>
      <div
        className={classes.trigger}
        style={{
          backgroundColor: value || '#ffffff',
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer'
        }}
        onClick={openPicker}
      />
      {open &&
        ReactDOM.createPortal(
          <div
            data-colorpicker-popover=""
            className={classes.popover}
            style={{ top: position.top, left: position.left }}>
            <HexColorPicker color={value || '#ffffff'} onChange={onChange} />
            <HexColorInput
              className={classes.hexInput}
              color={value || '#ffffff'}
              onChange={onChange}
              prefixed
            />
          </div>,
          document.body
        )}
    </div>
  )
}

export default ColorPickerField

const useStyles = makeStyles({
  wrapper: {
    width: '100%'
  },
  trigger: {
    width: '100%',
    height: '56px',
    borderRadius: '4px',
    border: '1px solid rgba(0,0,0,0.23)',
    boxSizing: 'border-box',
    '&:hover': {
      border: '1px solid rgba(0,0,0,0.87)'
    }
  },
  popover: {
    position: 'absolute',
    zIndex: 1500,
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
    overflow: 'hidden',
    backgroundColor: '#fff',
    padding: '0 0 12px'
  },
  hexInput: {
    display: 'block',
    width: `calc(${PICKER_WIDTH}px - 24px)`,
    margin: '12px auto 0',
    padding: '6px 10px',
    fontSize: '14px',
    fontFamily: 'inherit',
    border: '1px solid rgba(0,0,0,0.23)',
    borderRadius: '4px',
    boxSizing: 'border-box',
    textTransform: 'uppercase',
    '&:focus': {
      outline: 'none',
      border: '1px solid #3f51b5'
    }
  }
})
